import Image from 'next/image';

import { customLoader } from '../../utils/customLoaderImage';

import style from './vantagens.module.scss';

const parse = require('html-react-parser');

export default function Vantagens({ dados }) {
  if (!dados) return null;

  const { titulo, itens, icone } = dados;

  return (
    <div className={style.section}>
      <h2>{titulo && parse(titulo)}</h2>
      <div className={style.cards}>
        {itens.map((vantagem) => (
          <div
            key={vantagem.id}
            className={style.card}>
            <figure className={style.icon}>
              {icone && (
                <Image
                  alt='Ícone de item do plug apê'
                  src={icone || '/img/image_icon.png'}
                  loader={customLoader}
                  width={32}
                  height={32}
                />
              )}
              <figcaption>Ícone de item do plug apê</figcaption>
            </figure>
            <h3>{parse(vantagem.item)}</h3>
            <p>{parse(vantagem.descricao)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
